module.exports = {
  Register: require("./register"),
  NewLogin: require("./new_login"),
  Forgot: require("./forgot"),
  ChangePassword: require("./change_password"),
  Profile: require("./profile"),
};
